var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height ma-0 pa-0",attrs:{"fluid":""}},[_c('background-image',{attrs:{"src":_vm.background,"fitToHeight":true}},[_vm._t("default")],2),_vm._t("extra")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }